define('services/common/ajax/inAppNew',['app'], function (app) {
    app.factory('InAppNew', ['auiAjaxWithError', function (auiAjaxWithError) {

        return {
            checkLogin: auiAjaxWithError.curryOld('Inappnew.Developer.checkLogin'),
            queryBalance: auiAjaxWithError.curryOld('Inappnew.Developer.queryBalance'),

            addCfpTask: auiAjaxWithError.curryOld('Inappnew.Developer.createCloudFolderTask'),
            modifyCfpTask: auiAjaxWithError.curryOld('Inappnew.Developer.modifyCloudFolderTask'),
            deleteCfpTask: auiAjaxWithError.curryOld('Inappnew.Developer.deleteCloudFolderTask'),
            cancelCfpTask: auiAjaxWithError.curryOld('Inappnew.Developer.cancelCloudFolderTask'),
            getCfpTaskList: auiAjaxWithError.curryOld('Inappnew.Developer.queryCloudFolderTaskList'),
            getCfpTasKDetail: auiAjaxWithError.curryOld('Inappnew.Developer.queryCloudFolderTaskDetail'),
            queryCfpConfig: auiAjaxWithError.curryOld('Inappnew.Developer.queryCloudFolderConfig'),
            adAppAdd: auiAjaxWithError.curryOld('Inappnew.Developer.adAppAdd'),
            queryRemindInfo: auiAjaxWithError.curryOld('Inappnew.Developer.queryBalanceReminder'),
            modUserBalRemindInfo: auiAjaxWithError.curryOld('Inappnew.Developer.settingsBalanceReminder'),
            adAppInfo:auiAjaxWithError.curryOld('Inappnew.Developer.adAppInfo'),
            adAppDel:auiAjaxWithError.curryOld('Inappnew.Developer.adAppDel'),
            adSlotList:auiAjaxWithError.curryOld('Inappnew.Developer.adSlotList'),
            adAppAuditHisList:auiAjaxWithError.curryOld('Inappnew.Developer.adAppAuditHisList')



        }
    }])
});
